<template>
  <el-table-column
    prop="completing_user.last_name"
    label="Teljesítette"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.completing_user ? scope.row.completing_user.last_name + ' ' + scope.row.completing_user.first_name : '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'completing_user.last_name',
  };
</script>
